<template>
  <div  >

      <b-navbar type="dark" variant="dark">
      <div class="container">
        <a href="/" class="navbar-brand">
          <!-- Logo Image -->
          <img src="./itm.jpeg" width="45" alt="" class="d-inline-block align-middle mr-2">
          <!-- Logo Text -->
          <span class="text-uppercase font-weight-bold">HANDY LUX</span>
        </a>

              <b-navbar-nav>
                  <b-nav-item v-if="$store.state.user"  @click="$router.push({ path: '/ebayinvoice' })">Ebay Rechnungen</b-nav-item>
                  <b-nav-item v-if="$store.state.user"  @click="$router.push({ path: '/labels' })">Amazon Labels</b-nav-item>
                  <b-nav-item v-if="$store.state.user"  @click="$router.push({ path: '/uploadListing' })">Angebote hochladen</b-nav-item>
                  <b-nav-item-dropdown v-if="$store.state.user" text="Einstellungen" right>
                      <b-dropdown-item v-if="$store.state.user"  @click="$router.push({ path: '/ean' })">EAN Verwaltung</b-dropdown-item>
                      <b-dropdown-item v-if="$store.state.user"  @click="$router.push({ path: '/uploadsettings' })">Upload Einstellungen</b-dropdown-item>
                      <b-dropdown-item v-if="$store.state.user"  @click="$router.push({ path: '/listingsize' })">Angebot Maße</b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item @click="$router.push({ path: '/contact' })">Kontakt</b-nav-item>
              </b-navbar-nav>
        <button class="btn btn btn-outline-danger my-2 mr-2 my-sm-0" v-if="$store.state.user" @click.prevent="logout" >Logout</button>
      </div>
      </b-navbar>
    <div class="logo mb-3">
<!--      <div class="col-md-12 text-center">-->
<!--        <h1>Handy Lux Portal</h1>-->
<!--      </div>-->
    </div>
    <router-view class="router-content"></router-view>

    <footer class="text-lg-start bg-light text-muted">
      <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.05);">
        © 2021-2022 Copyright:
        <a class="text-reset fw-bold" href="https:/hl.it-mood.de/">it-mood.de</a>
         v2.11.14
      </div>


      <!-- Copyright -->
    </footer>
  </div>

</template>

<script>
    // import Api from './api'
  export default{

    methods:{

      goToAbout(){
        console.log("go To About")
        this.$router.push({ path: 'about' })
      },
      logout(){
        this.$cookies.remove("authToken")
        localStorage.removeItem("authToken")
        this.$router.push({ path: '/' })
        console.log("log out")
     },

    }
  }
</script>

<style>

  body {
    margin: 0;
    font-family: var(--bs-font-sans-serif);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #f5f5f5;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  footer {
      height: 50px;
    position:fixed;
    left:0px;
    bottom:0px;
    width:100%;
    background:#999;
  }

    .router-content{
        margin-bottom: 60px;
    }





</style>
